import { getAssetLotsPlainAPI, getTransactionStatusAPI, getTransactionAssetsByType } from "../../config/apiConfig";
import {
  FETCH_ASSETLOT_PLAIN_BEGIN,
  FETCH_ASSETLOT_PLAIN_FAILURE,
  FETCH_ASSETLOT_PLAIN_SUCCESS,
  FETCH_TRANSACTION_STATUS_BEGIN,
  FETCH_TRANSACTION_STATUS_FAILURE,
  FETCH_TRANSACTION_STATUS_SUCCESS,
  FETCH_TRANSACTION_ASSETBYTYPE_BEGIN,
  FETCH_TRANSACTION_ASSETBYTYPE_SUCCESS,
  FETCH_TRANSACTION_ASSETBYTYPE_FAILURE,
} from "../constants/transaction";
import { sbaAxios } from "../utils/sbaAxios";

export const getTransactionStatusAction=()=>{
        return (dispatch) => {
            dispatch(fetchTransactionStatusBegin());
            sbaAxios({url:`${getTransactionStatusAPI}`})       
            .then((repos) => {
              const status = repos;
              dispatch(fetchTransactionStatusSuccess(status));
              return status;
            })
            .catch((error) => dispatch(fetchTransactionStatusFailure(error)));
        };
};
const fetchTransactionStatusBegin = () => ({
    type: FETCH_TRANSACTION_STATUS_BEGIN,
});
const fetchTransactionStatusSuccess = (status) => ( {
    type: FETCH_TRANSACTION_STATUS_SUCCESS,
    payload: { status },
});
const fetchTransactionStatusFailure = (errorMessage) => ({
    type: FETCH_TRANSACTION_STATUS_FAILURE,
    payload: { errorMessage }
});

export const getAssetLotsPlain=(entityID)=>{
    return (dispatch) => {
        dispatch(fetchAssetLotsPlainBegin());
        sbaAxios({url:`${getAssetLotsPlainAPI}${entityID}`})       
        .then((repos) => {
          const status = repos;
          dispatch(fetchAssetLotsPlainSuccess(status));
          return status;
        })
        .catch((error) => dispatch(fetchAssetLotsPlainFailure(error)));
    };
};
const fetchAssetLotsPlainBegin = () => ({
    type: FETCH_ASSETLOT_PLAIN_BEGIN,
});
const fetchAssetLotsPlainSuccess = (lots) => ( {
    type: FETCH_ASSETLOT_PLAIN_SUCCESS,
    payload: { lots },
});
const fetchAssetLotsPlainFailure = (errorMessage) => ({
    type: FETCH_ASSETLOT_PLAIN_FAILURE,
    payload: { errorMessage }
});

export const getAssetsByType = (transTypeId, searchString) => {
    return (dispatch) => {
        dispatch(fetchAssetsByTypeBegin());
        sbaAxios({
            url: `${getTransactionAssetsByType}?transTypeId=${transTypeId}&searchString=${searchString}`,
            method: 'get',
        })
        .then((repos) => {
          const assetsByType = repos;
          dispatch(fetchAssetsByTypeSuccess(assetsByType));
          return assetsByType;
        })
        .catch((error) => dispatch(fetchAssetsByTypeFailure(error)));
    };
};
const fetchAssetsByTypeBegin = () => ({
    type: FETCH_TRANSACTION_ASSETBYTYPE_BEGIN,
});
const fetchAssetsByTypeSuccess = (assetsByType) => ( {
    type: FETCH_TRANSACTION_ASSETBYTYPE_SUCCESS,
    payload: { assetsByType },
});
const fetchAssetsByTypeFailure = (errorMessage) => ({
    type: FETCH_TRANSACTION_ASSETBYTYPE_FAILURE,
    payload: { errorMessage }
});